import React from 'react';
import { Link } from 'react-router-dom';

import { logEvent } from 'src/eventAnalytics';
import { useUsername } from 'src/store/selectors';
import { colors } from 'src/style';
import './CompareToLanding.css';
import '../components/BigButton.css';

const CompareToLanding: React.FC = () => {
  const { username, displayName } = useUsername();

  return (
    <div className="compare-to-landing">
      <Link to="/" style={{ textDecorationColor: '#ccc' }}>
        <div className="compare-to-landing-header">
          <img
            src="/spotifytrack-smaller.jpg"
            style={{ height: 34, width: 34, marginRight: 6, marginLeft: -4, marginTop: -2 }}
            alt="spotifytrack logo"
          />
          <h2>Spotifytrack</h2>
        </div>
      </Link>
      <h1>
        Compare your musical taste to{' '}
        <span style={{ color: colors.pink, whiteSpace: 'nowrap' }}>{displayName ?? '...'}</span>
      </h1>

      <div className="content-embed">
        <p>
          Connect your Spotify account to Spotifytrack to visualize the overlap in artists and
          tracks and generate a shared taste playlist.
        </p>
        <p>
          100% free, no caveats - just cool data! Only your Spotify listening data is obtained; no
          access to your account is granted.
        </p>

        <div style={{ textAlign: 'center' }}>
          <Link
            to={`/connect?state=${encodeURIComponent(JSON.stringify({ compare_to: username }))}`}
          >
            <button
              className="big-button"
              onClick={() => logEvent('oauth', 'connect_click', { from: 'compare_landing' })}
            >
              Connect to Spotify
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CompareToLanding;
